import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

// const options = zod.enum([...Permissions.options]);

export const SipClientFormSchema = zod.object({
  id: zod.number().optional(),
  username: zod.string({ required_error: MANDATORY_FIELD }),
  password: zod.string({ required_error: MANDATORY_FIELD }),
  domain: zod.string({ required_error: MANDATORY_FIELD }),
  displayName: zod.string({ required_error: MANDATORY_FIELD }),
  sipServerUrl: zod.string({ required_error: MANDATORY_FIELD }),
  ownerUserId: zod.string({ required_error: MANDATORY_FIELD }),
  isRegistered: zod.boolean(),
});
